import { cn } from '@/lib/utils';

export interface HelpCenterProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export function HelpCenter({
  size = 20,
  width,
  height,
  fill = '#061A61',
  className,
  ...props
}: HelpCenterProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 15 15"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M8.54167 11.45C8.54167 12.025 8.1 12.5 7.5 12.5C6.91667 12.5 6.45 12.0333 6.45 11.45C6.45 10.8583 6.91667 10.4083 7.5 10.4083C8.09167 10.4083 8.54167 10.8667 8.54167 11.45ZM7.49167 2.5C6.01667 2.5 5.00833 3.45833 4.63333 4.575L6 5.15C6.18333 4.59167 6.61667 3.91667 7.5 3.91667C8.85 3.91667 9.11667 5.18333 8.64167 5.85833C8.19167 6.5 7.41667 6.93333 7.00833 7.65833C6.68333 8.23333 6.75 8.9 6.75 9.30833H8.26667C8.26667 8.53333 8.325 8.375 8.45 8.13333C8.775 7.53333 9.375 7.25 10.0083 6.325C10.575 5.49167 10.3583 4.35833 9.99167 3.75833C9.56667 3.05833 8.725 2.5 7.49167 2.5ZM13.3333 1.66667H1.66667V13.3333H13.3333V1.66667ZM13.3333 0C14.25 0 15 0.75 15 1.66667V13.3333C15 14.25 14.25 15 13.3333 15H1.66667C0.75 15 0 14.25 0 13.3333V1.66667C0 0.75 0.75 0 1.66667 0H13.3333Z"
        fill={fill}
      />
    </svg>
  );
}
